import { InjectionToken } from "@angular/core";

export const CONFIG_DATA = new InjectionToken("configData");
